import React from 'react';
import { useNotification } from '../../../context/NotificationContext';
import Toast from '../Toast/Toast';
import './ToastContainer.css';

const ToastContainer = () => {
  const { toasts, removeToast } = useNotification();

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={removeToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
